import React from 'react'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Loader from '../../../components/Loader';
import useLoading from '../../../hooks/useLoading';

const AdminMessageInbox = () => {
    const location = useLocation();
    const inboxItem = location.state?.inboxItem;
    const { isLoading } = useLoading();
    
    // If no inboxItem is provided, show a message
    if (!inboxItem) {
        return (
            <div className="page-container col-sm-9" style={{ top: '20px' }}>
                <div id="inbox-message" className="col-sm-12 mb-5 pb-5">
                    <div className="heading-golfer" style={{ height: '44px' }}>
                        <h4 style={{ position: 'relative', top: '-10px' }}>Message Preview</h4>
                    </div>
                    <div className="alert alert-warning">
                        No message data available. Please go back to the inbox and select a message.
                    </div>
                </div>
            </div>
        );
    }
    
    return (
        <div className="page-container col-sm-9" style={{ top: '20px' }}>
            <div id="inbox-message" className="col-sm-12 mb-5 pb-5">
                <div className="heading-golfer" style={{ height: '44px' }}>
                    <h4 style={{ position: 'relative', top: '-10px' }}>Message Preview</h4>
                </div>
                <div id="msgheader">
                    <h2>From: <b>{inboxItem?.sender}</b></h2>
                    <h2>Subject: <b>{inboxItem?.receiverName}</b></h2>
                </div>
                <p className="msg-head">Message:</p>
                <div id="msg">
                {inboxItem.message}
                </div>
                <Link to={`/carter/sendMessage?userId=${inboxItem.senderId}`} className="reply-link  d-inline-block pb-5 mb-5">Reply to Message</Link>
            </div>
        </div>

    );
}

export default AdminMessageInbox